'use strict';

angular.module('imagetrend.components')
    .controller('hlpBigElementController', ['$scope', '$q', 'LicenseRequestLevels', 'CertificationLevels', 'ApplicationTypes', 'LicenseRequestApplicationTypes', 'LicenseLevelConfigurations', '$state', function ($scope, $q, LicenseRequestLevels, CertificationLevels, ApplicationTypes, LicenseRequestApplicationTypes, LicenseLevelConfigurations, $state) {

        $scope.loading = true;
        $scope.portal = $state.current.data.isPortal;
        var promises = [];

        promises.push(LicenseRequestLevels.get({ data_type: 'User' }).then(function (levels) {
            $scope.allLevels = levels;
        }))

        if ($scope.parameters.user_id != null) {
            promises.push(LicenseRequestLevels.get($scope.parameters).then(function (levels) {
                $scope.currentLevels = levels;
            }))
        }
        else {
            $scope.currentLevels = [];
        }

        promises.push(ApplicationTypes.get({ data_type: 'User' }).then(function (types) {
            $scope.applicationTypes = types;
        }))

        if ($scope.parameters.user_id != null) {
            promises.push(CertificationLevels.get($scope.parameters).then(function (certLevels) {
                $scope.certificationLevels = certLevels;
            }))
        }
        else {
            $scope.certificationLevels = [];
        }

        if ($scope.parameters.license_request_id != null) {
            promises.push(LicenseRequestApplicationTypes.get($scope.parameters).then(function (lrat) {
                $scope.licenseRequestApplicationTypes = lrat;
            }))
        }
        else {
            $scope.licenseRequestApplicationTypes = [];
        }

        promises.push(LicenseLevelConfigurations.get($scope.parameters).then(function (config) {
            $scope.levelConfig = config;
        }))

        $q.all(promises).then(function () {
            var initProms = [];

            if ($scope.licenseRequestApplicationTypes.length == 0) {
                var renewalType = null;
                $scope.applicationTypes.forEach(function(type) {
                    if (type.renewal) {
                        renewalType = type.id;
                    }
                });

                $scope.currentLevels.forEach(function (level) {
                    $scope.levelConfig.forEach(function (config) {
                        if (renewalType != null && config.application_type_id == renewalType && config.license_request_level_id == level.id) {
                            initProms.push(LicenseRequestApplicationTypes.save({ license_request_id: $scope.parameters.license_request_id, application_type_id: renewalType, license_request_level_id: level.id, checked: true }).then(function (lrat) {
                                $scope.licenseRequestApplicationTypes.push(lrat);
                            }));
                        }
                    });
                });
            }

            $q.all(initProms).then(function () {
                if ($scope.component.elementAnswer == null) {
                    $scope.component.elementAnswer = {};
                    $scope.licenseRequestApplicationTypes.forEach(function (lrat) {
                        $scope.component.elementAnswer[lrat.application_type_id + '%' + lrat.license_request_level_id] = lrat.checked;
                    });
                }
                $scope.loading = false;
            })
                .catch(function (response) {
                    // handle error
                });                ;
        })
            .catch(function (response) {
                // handle error
            });            ;

        $scope.showLevel = function (type, level) {
            var show = false;

            $scope.levelConfig.forEach(function (config) {
                if (config.application_type_id == type.id && config.license_request_level_id == level.id) {
                    if (type.renewal) {
                        if ($scope.portal) {
                            $scope.currentLevels.forEach(function (curLevel) {
                                if (curLevel.license_category_level_id == level.license_category_level_id || curLevel.data_element_id == level.data_element_id || level.data_element_id == null) {
                                    show = true;
                                }
                                else {
                                    $scope.certificationLevels.forEach(function (certLevel) {
                                        if (level.license_category_level_id == certLevel.license_category_level_id) {
                                            $scope.component.elementAnswer[type.id + '%' + level.id] = true;
                                            show = true;
                                        }
                                    })
                                }
                            })
                        }
                        else {
                            show = true;
                        }
                    }
                    else {
                        show = true;
                    }
                }
            })

            if (show && $scope.component.elementAnswer[type.id + '%' + level.id] == null) {
                $scope.component.elementAnswer[type.id + '%' + level.id] = false;
            }

            return show;
        }

        $scope.clear = function () {
            for (var key in $scope.component.elementAnswer) {
                $scope.component.elementAnswer[key] = false;
            }
        }

        $scope.levelChange = function(type, level) {
            for (var key in $scope.component.elementAnswer) {
                if (key == (type.id + '%' + level.id)) {
                    $scope.component.elementAnswer[key] = true;
                } else if (key.indexOf('%' + level.id) >= 0) {
                    $scope.component.elementAnswer[key] = false;
                }
            }
        }
    }])
    .directive('hlpBigElement', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/big-element/big-element.html',
            replace: true,
            controller: 'hlpBigElementController',
            scope: {
                parameters: '=?',
                component: '=?',
                pdf: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;